// sagas/eventSaga.js

import { call, all, takeEvery } from 'redux-saga/effects';
import {
  listEventsRequest,
  searchEventsRequest,
  filterEventsRequest,
  exportEventsRequest,
  getEventInfoRequest,
  updateEventInfoRequest,
  addEventRequest
} from '../../api/event'; // API imports
import {
  listEvents,
  searchEvents,
  filterEvents,
  exportEvents,
  getEventInfo,
  updateEventInfo,
  addEvent
} from '../actions/event'; // Promise actions

import { resolvePromiseAction, rejectPromiseAction } from '@adobe/redux-saga-promise';

import { translateErrorResponse } from '../../utils/utils';

// Saga to handle listing events
export function* handleListEvent(action) {
  try {
    const response = yield call(listEventsRequest, action.payload);
    yield call(resolvePromiseAction, action, response?.data?.data ?? {}); // Resolve the promise action
  } catch (err) {
    const errorMessage = translateErrorResponse(err).message;
    yield call(rejectPromiseAction, action, errorMessage); // Reject the promise action
  }
}

// Saga to handle searching events
export function* handleSearchEvent(action) {
  try {
    const response = yield call(searchEventsRequest, action.payload);
    yield call(resolvePromiseAction, action, response?.data ?? {}); // Resolve the promise action
  } catch (err) {
    const errorMessage = translateErrorResponse(err).message;
    yield call(rejectPromiseAction, action, errorMessage); // Reject the promise action
  }
}

// Saga to handle filtering events
export function* handleFilterEvent(action) {
  try {
    const response = yield call(filterEventsRequest, action.payload);
    yield call(resolvePromiseAction, action, response?.data ?? {}); // Resolve the promise action
  } catch (err) {
    const errorMessage = translateErrorResponse(err).message;
    yield call(rejectPromiseAction, action, errorMessage); // Reject the promise action
  }
}

// Saga to handle exporting events
export function* handleExportEvent(action) {
  try {
    const response = yield call(exportEventsRequest, action.payload);
    yield call(resolvePromiseAction, action, response?.data ?? {}); // Resolve the promise action
  } catch (err) {
    const errorMessage = translateErrorResponse(err).message;
    yield call(rejectPromiseAction, action, errorMessage); // Reject the promise action
  }
}

// Saga to handle viewing event details
export function* handleGetEventInfo(action) {
  try {
    const response = yield call(getEventInfoRequest, action.payload);
    yield call(resolvePromiseAction, action, response?.data ?? {}); // Resolve the promise action
  } catch (err) {
    const errorMessage = translateErrorResponse(err).message;
    yield call(rejectPromiseAction, action, errorMessage); // Reject the promise action
  }
}

// Saga to handle updating event info
export function* handleUpdateEventInfo(action) {
  try {
    const response = yield call(updateEventInfoRequest, action.payload);
    yield call(resolvePromiseAction, action, response?.data ?? {}); // Resolve the promise action
  } catch (err) {
    const errorMessage = translateErrorResponse(err).message;
    yield call(rejectPromiseAction, action, errorMessage); // Reject the promise action
  }
}

// Saga to handle adding a event
export function* handleAddEvent(action) {
  try {
    const response = yield call(addEventRequest, action.payload);
    yield call(resolvePromiseAction, action, response?.data ?? {}); // Resolve the promise action
  } catch (err) {
    const errorMessage = translateErrorResponse(err).message;
    yield call(rejectPromiseAction, action, errorMessage); // Reject the promise action
  }
}

// Root saga to watch for event actions
export default function* eventSaga() {
  yield all([
    takeEvery(listEvents.trigger, handleListEvent), // Watch for listEvents action
    takeEvery(searchEvents.trigger, handleSearchEvent), // Watch for searchEvents action
    takeEvery(filterEvents.trigger, handleFilterEvent), // Watch for filterEvents action
    takeEvery(exportEvents.trigger, handleExportEvent), // Watch for exportEvents action
    takeEvery(getEventInfo.trigger, handleGetEventInfo), // Watch for getEventInfo action
    takeEvery(updateEventInfo.trigger, handleUpdateEventInfo), // Watch for updateEventInfo action
    takeEvery(addEvent.trigger, handleAddEvent), // Watch for addEvent action
  ]);
}
